module.exports = __webpack_public_path__ + "static/media/shields.1fd78133.png";